import { useEvidenceConfig } from './useEvidenceConfig';

export const useVisualizationConfig = (focusId: string) => {
  const { config } = useEvidenceConfig(focusId);
  
  const getCoverageColor = (percentage: number): string => {
    const thresholds = config.visualizationThresholds?.coverage_colors || {
      high: { threshold: 60, color: 'green' },
      medium: { threshold: 30, color: 'yellow' },
      low: { threshold: 0, color: 'red' }
    };
    
    // Sort thresholds by threshold value descending
    const sortedThresholds = Object.values(thresholds)
      .sort((a, b) => b.threshold - a.threshold);
    
    // Find the first threshold that the percentage meets
    for (const level of sortedThresholds) {
      if (percentage >= level.threshold) {
        // Map color names to Tailwind classes
        switch (level.color) {
          case 'green':
            return 'bg-green-500';
          case 'yellow':
            return 'bg-yellow-500';
          case 'red':
            return 'bg-red-500';
          case 'blue':
            return 'bg-blue-500';
          case 'purple':
            return 'bg-purple-500';
          case 'orange':
            return 'bg-orange-500';
          default:
            return 'bg-gray-500';
        }
      }
    }
    
    return 'bg-red-500'; // Default fallback
  };
  
  const getCoverageTextColor = (percentage: number): string => {
    const thresholds = config.visualizationThresholds?.coverage_colors || {
      high: { threshold: 60, color: 'green' },
      medium: { threshold: 30, color: 'yellow' },
      low: { threshold: 0, color: 'red' }
    };
    
    // Sort thresholds by threshold value descending
    const sortedThresholds = Object.values(thresholds)
      .sort((a, b) => b.threshold - a.threshold);
    
    // Find the first threshold that the percentage meets
    for (const level of sortedThresholds) {
      if (percentage >= level.threshold) {
        // Map color names to Tailwind text classes
        switch (level.color) {
          case 'green':
            return 'text-green-600 dark:text-green-400';
          case 'yellow':
            return 'text-yellow-600 dark:text-yellow-400';
          case 'red':
            return 'text-red-600 dark:text-red-400';
          case 'blue':
            return 'text-blue-600 dark:text-blue-400';
          case 'purple':
            return 'text-purple-600 dark:text-purple-400';
          case 'orange':
            return 'text-orange-600 dark:text-orange-400';
          default:
            return 'text-gray-600 dark:text-gray-400';
        }
      }
    }
    
    return 'text-red-600 dark:text-red-400'; // Default fallback
  };
  
  return {
    getCoverageColor,
    getCoverageTextColor,
    thresholds: config.visualizationThresholds?.coverage_colors
  };
};